import { render, staticRenderFns } from "./CustomerSummaryNet.vue?vue&type=template&id=0b08b96d"
import script from "./CustomerSummaryNet.vue?vue&type=script&lang=ts"
export * from "./CustomerSummaryNet.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSummaryNet.vue?vue&type=style&index=0&id=0b08b96d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports